import { Component, ChangeDetectionStrategy, Inject } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { NgZoneHelperService } from '@alliance/shared/utils'
import { StaticTooltipViewHelperService } from '../services/static-tooltip-view-helper.service'
import { BaseStaticTooltipDirective } from '../base-static-tooltip.directive'
import { PushAnalyticsEventsService } from '@alliance/ats/analytics/utils'

const TOOLTIP_SELECTOR = 'tooltip'

@Component({
  selector: 'alliance-ats-static-directive-tooltip',
  templateUrl: './static-directive-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticDirectiveTooltipComponent extends BaseStaticTooltipDirective {
  public constructor(
    @Inject(DOCUMENT) document: Document,
    ngZoneHelper: NgZoneHelperService,
    staticTooltipViewHelperService: StaticTooltipViewHelperService,
    pushAnalyticsEventsService: PushAnalyticsEventsService
  ) {
    super(staticTooltipViewHelperService, document, ngZoneHelper, pushAnalyticsEventsService)
    this.set({ tooltipSelector: TOOLTIP_SELECTOR })
  }
}
